import { hasStoredAccessToken } from "./tabHeartbeat";

export const SESSION_LAST_ACTIVITY_KEY = "session_last_activity";

const CLIENT_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes
const STAFF_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

export function getInactivityTimeoutMs(role) {
  const normalized = String(
    role || (typeof localStorage !== "undefined" && localStorage.getItem("user_role")) || "",
  )
    .trim()
    .toLowerCase();
  return normalized === "client" ? CLIENT_TIMEOUT_MS : STAFF_TIMEOUT_MS;
}

export function getSessionLastActivity() {
  if (typeof localStorage === "undefined") return 0;
  const raw = parseInt(localStorage.getItem(SESSION_LAST_ACTIVITY_KEY) || "0", 10);
  return Number.isFinite(raw) && raw > 0 ? raw : 0;
}

export function touchSessionActivity(timestamp = Date.now()) {
  if (typeof localStorage === "undefined") return;
  if (!localStorage.getItem("user_id")) return;
  localStorage.setItem(SESSION_LAST_ACTIVITY_KEY, String(timestamp));
}

export function hasPersistedAuth() {
  if (typeof localStorage === "undefined") return false;
  return Boolean(localStorage.getItem("user_id")) || hasStoredAccessToken();
}

/**
 * True when stored auth exists but inactivity window has elapsed.
 * Missing last-activity for an existing session is treated as expired.
 */
export function isSessionExpired({ now = Date.now(), role } = {}) {
  if (!hasPersistedAuth()) return false;

  const lastActivity = getSessionLastActivity();
  if (!lastActivity) return true;

  const timeout = getInactivityTimeoutMs(role);
  return now - lastActivity >= timeout;
}

export function clearAuthStorage() {
  if (typeof localStorage !== "undefined") {
    localStorage.removeItem(SESSION_LAST_ACTIVITY_KEY);
    localStorage.clear();
  }
  try {
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.clear();
    }
  } catch (_) {
    /* ignore */
  }
}
